import styled from 'styled-components';
import Button from '../Button';

import { outlineGray, primaryColor } from '../../config/colors';

export const IdCardWrapper = styled.div`
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  border-bottom: 1px darkGray solid;
  border-right: 0px;
  border-left: 0px;
  border-top: 0.5px darkGray solid;
  padding-bottom: 60px;
`;

export const TitleAndCommandsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
export const TitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  margin-left: 65px;
  margin-bottom: 60px;
  padding-right: 40px;
  flex-grow: 1;
  flex-wrap: wrap;
`;

export const DescriptionAndMainImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const IdCardTitle = styled.h1`
  margin: 0px;
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 1.5rem;
  display: inline-flex;
  min-width: 300px;
`;

export const ModuleTitleAndInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  margin-bottom: 15px;
`;

export const ModuleTitle = styled.p`
  font-weight: 500;
  font-size: 1.25rem;
  display: inline-flex;
  min-width: 300px;
`;

export const ModuleTitleInput = styled.input`
  width: 75%;
  height: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 0.875rem;
`;

export const DropDownWrapper = styled.div`
  width: 75%;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const CommandsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline: 15px;
`;

export const SaveChangesExitWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: space-between;
  padding-top: 20px;
`;

export const TextualDetailsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-left: 50px;
  padding-right: 85px;
`;

export const SectionTitle = styled(ModuleTitle)`
  margin-left: 15px;
`;

export const SubMenusWrapper = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-left: 50px;
  padding-right: 85px;
  margin-top: 20px;
`;

export const SaveChangesButton = styled(Button).attrs({
  wrapperStyle: {
    marginRight: '30px',
    width: '150px',
  },
  textStyle: {
    fontWeight: '600',
  },
})``;

export const DiscardChangesButton = styled(Button).attrs({
  wrapperStyle: {
    marginTop: '10px',
    width: '150px',
  },
  textStyle: {
    color: `${primaryColor}`,
    fontWeight: '600',
  },
})``;

export const DeleteIdCardButton = styled(Button).attrs({
  // TODO
  wrapperStyle: {
    marginTop: '88px',
    border: '1px dashed red',
    width: '150px',
  },
  textStyle: {
    color: 'red',
    fontWeight: '600',
  },
})``;

export const OriginalCharacteristics = styled.div`
  font-size: 10px;
  white-space: pre-line;
`;

export const OriginalCharacteristicsWrapper = styled.div`
  padding: 1em;
  border: 1px dashed #aaa;
`;
